import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { NbJSThemeVariable, NbMediaBreakpoint, NbMediaBreakpointsService, NbThemeService } from '@nebular/theme';

@Component({
  selector: 'ngx-transactions-charts-header',
  styleUrls: ['./transactions-chart-header.component.scss'],
  templateUrl: './transactions-chart-header.component.html',
})
export class TransactionsChartHeaderComponent implements OnDestroy {

  @Output() periodChange = new EventEmitter<string>();

  @Input() type: string = 'semana';

  chartLegend: { iconColor: string; title: string }[];
  breakpoint: NbMediaBreakpoint = { name: '', width: 0 };
  breakpoints: any;
  currentTheme: string;

  constructor(private themeService: NbThemeService) {
    this.themeService.getJsTheme()
      .subscribe(theme => {
        const orderProfitLegend = theme.variables.orderProfitLegend;

        this.currentTheme = theme.name;
        this.setLegendItems(orderProfitLegend);
      });
  }

  setLegendItems(orderProfitLegend: any | NbJSThemeVariable) {
    this.chartLegend = [
      {
        iconColor: orderProfitLegend.thirdItem,
        title: 'Todas transações',
      },
      {
        iconColor: "rgb(0 217 149)",
        title: 'Confirmadas',
      },
      {
        iconColor: "#ffcc5c",
        title: 'Canceladas',
      },
    ];
  }

  changePeriod(period: string): void {
    this.type = period;
    this.periodChange.emit(period);
  }

  ngOnDestroy() {
  }
}
